import { IAppState } from '../../../../AppModulesWrapper';

import { selectIsSubagent } from '../../user';
import { selectPlacingMoneySource } from '../selectPlacingMoneySource';
import { selectActivePlacingType } from '../selectActivePlacingType';
import { EMoneySource } from '../../../types/reducers/user';
import { EPlacingType } from '../../../types/reducers/publishTerms';

export const selectIsChangePackageDisable = (state: IAppState): boolean => {
  const isSubagent = selectIsSubagent(state);
  const placingMoneySource = selectPlacingMoneySource(state);
  const activePlacingType = selectActivePlacingType(state);

  return isSubagent && placingMoneySource === EMoneySource.Self && activePlacingType === EPlacingType.package;
};
